import { render, staticRenderFns } from "./ModalViewsClaim.vue?vue&type=template&id=33080bcc&lang=pug&"
import script from "./ModalViewsClaim.vue?vue&type=script&lang=js&"
export * from "./ModalViewsClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports